import { Component } from '@angular/core';
import {
  AuthService,
  LoginResponse,
} from '../../core/service/authentication/auth.service';
import { ModalService } from '../../core/service/modal/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import ErrorResponse from '../../core/models/common/error-response.model';
import { ApiResponseStatus } from '../../core/models/common/enums/api-response-status.enum';
import { ApiResponseErrorCodes } from '../../core/models/common/enums/api-response-error-codes.enum';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
})
export class LoginModalComponent {
  loginForm: FormGroup = new FormGroup({
    emailAddress: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });

  invalidCredentials = false;
  inactiveAccount = false;
  isPasswordVisible = false;

  constructor(
    private authService: AuthService,
    private modalService: ModalService
  ) { }

  login(): void {
    this.authService
      .login(this.loginForm.value.emailAddress, this.loginForm.value.password)
      .subscribe((response) => {
        switch (response.status) {
          case ApiResponseStatus.Ok: {
            const authResponse = response.content as LoginResponse;

            this.authService.setCurrentUserId(authResponse.user.id ?? '');
            this.authService.setAuthenticationToken(
              authResponse.authorization.token
            );

            location.reload();
            break;
          }
          case ApiResponseStatus.Error: {
            const errorResponse = response.content as ErrorResponse;

            if (errorResponse.type === ApiResponseErrorCodes.UserBadCredentials)
              this.invalidCredentials = true;
            else if (errorResponse.type === ApiResponseErrorCodes.UserNotActive)
              this.invalidCredentials = true;

            break;
          }
        }
      });
  }

  openForgotPasswordModal() {
    this.modalService.openModal('forgotPassword');
  }

  openRegisterModal() {
    this.modalService.openModal('register');
  }

  /*===== SHOW PSW EYE ========*/

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

}
